__webpack_require__.p = "https://aximoix.com/";